export const EMAIL_REGEX =
  /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/;

export const API_BASE_URL=process.env.REACT_APP_ENV == 'prod' ? 'https://api.getdone.com/' : 'https://api.qa.getdone.com/';
// export const API_BASE_URL='http://localhost:8080/';
// export const API_BASE_URL='https://api.getdone.com/';